module.exports = __webpack_public_path__ + "static/media/Cocción al Vacio.045ad95a.jpg";